module.exports = __webpack_public_path__ + "img/1440.a5137d19.jpg";